





























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiChip extends Vue { 
  @Prop({default:'4px'}) 
  chipStyle: 'round' | '4px';
  
  prependText: string;
  
  @Prop()
  contentColor: string;

  @Prop() 
  prependIcon: string;

  @Prop()
  backgroundColor: string;

  @Prop() 
  hasClose: boolean | string;

  @Prop()
  selected: boolean;

  get pHasClose() {
    return this.hasClose === '' || this.hasClose;
  }
}
